import React from 'react'

import { TextClamp } from '../components/text/TextClamp'

/**
 * The footnote slot (plots plan Stage 2, AA): a small note under a plot (podium's
 * caveat, price-sensitivity's base and method line), 12px, clamped to its line budget.
 */
export interface SlotFootnoteProps {
  children: React.ReactNode
  maxLines: number
  lineHeight: string
  color: string
  /** Extra layout style (alignment, a margin), as the host places it. */
  style?: React.CSSProperties
  testId?: string
  renderMode?: 'interactive' | 'static'
}

export function SlotFootnote(props: SlotFootnoteProps) {
  const { children, maxLines, lineHeight, color, style, testId, renderMode } = props
  return (
    <TextClamp
      data-testid={testId}
      minLines={1}
      maxLines={maxLines}
      lineHeight={lineHeight}
      renderMode={renderMode}
      style={{ fontSize: 12, color, ...style }}
    >
      {children}
    </TextClamp>
  )
}
